import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import WhyUs from '../components/WhyUs';
import Gallery from '../components/Gallery';
import Payment from '../components/Payment';
import CTA from '../components/CTA';
import Testimonials from '../components/Testimonials';
import InstagramFeed from '../components/InstagramFeed';
import Partners from '../components/Partners';
import Outlets from '../components/Outlets';
import Footer from '../components/Footer';
import FloatingWA from '../components/FloatingWA';

const Home = () => {
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add('in');
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="font-body">
      <Header />
      <Hero />
      <Services />
      <About />
      <WhyUs />
      <Gallery />
      <Payment />
      <CTA />
      <Testimonials />
      <InstagramFeed />
      <Partners />
      <Outlets />
      <Footer />
      <FloatingWA />
    </div>
  );
};

export default Home;
